module.exports = __webpack_public_path__ + "static/media/ADR.4dd8e72d.JPG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/ADR.JPG
// module id = 1706
// module chunks = 1